import { apiClient } from './client';
import type { AppLoginRequest, AppLoginResponse } from '../types/api';

export const appApi = {
  /** Login MANUAL — input username + password Super User. Fallback. */
  login: (body: AppLoginRequest) =>
    apiClient.post<AppLoginResponse>('/app/login', body, true),

  /** Login OTOMATIS — tanpa password. Username = username klien (anchor). */
  loginOtomatis: (idPerusahaan: string) =>
    apiClient.post<AppLoginResponse>('/app/login-otomatis', { idPerusahaan }, true),
};
